import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { assistanceStartRegisterAdmin } from "../../app/actions/assistanceActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidations from "../../app/hooks/useFormValidations";
import useModuleNewEditFields from "../../app/hooks/useModuleNewEditFields";
import { attachModuleFormScope } from "../../app/helpers/moduleFormScopeHelper";
import { attachPreDriTermOrWarn } from "../../app/helpers/preDriTermLinkHelper";
import PreDriCreateBar from "../specialist-selection/PreDriCreateBar";
import NavbarIconsModuleContext from "../generic-nav-bar/NavbarIconsModuleContext";
import FlowFichaSections from "../specialist-flow-engine/components/FlowFichaSections";
import { hydrateCatalogSelectFields } from "../../app/helpers/helperCatalogs";

const NewAssistance = () => {
  debugLogPages(':: NewAssistance');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  /********Store*******/

  const { listFullCatalogCiius, listCatalogCiiusLevel1, listCatalogCiiusLevel2, listCatalogCiiusLevel3, listCatalogCiiusLevel4, listCatalogCiiusLevel5, listCatalogCiiusLevel6 } =
    useSelector((state) => state.catalogCiiu);

  const { listCatalogSectionsLevel1, listCatalogSectionsLevel2, listCatalogSectionsLevel3 } =
    useSelector((state) => state.catalogSection);

  const { listCatalogPhasesLevel1, listCatalogPhasesLevel2, listCatalogPhasesLevel3, listCatalogPhasesLevel4 } =
    useSelector((state) => state.catalogPhase);

  const { listFullCatalogInstitutions, listCatalogInstitutionsLevel1, listCatalogInstitutionsLevel2, listCatalogInstitutionsLevel3 } =
    useSelector((state) => state.catalogInstitution);

  const { listContinents, listRegions, listCountries } = useSelector((state) => state.locationCountry);

  const { validationFields, arrayListPrincipal, arrayListSecondary, visibilityFlag } = useModuleNewEditFields("assistance");

  const { listSeries, listSophistications, listMagnitudes, listSizes, listTypologies, listGeneralAdaptations, listStructuralAdaptations, listSpecificAdaptations, listProblems, listMultimedias, listPriceRanges,
    listPermissionPublish } = useSelector((state) => state.catalog);

  /********UseForm*******/
  const { values, errors, handleChange, handleChangeMulti, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeCatalogInstitution, handleChangeLocation, setValues } = useFormValidations(
      () => AssistanceCallback(),
      {},
      validationFields
    );

  /********useState y useEffect*******/
  const [isDisabledProcessButton] = useState(false);

  useEffect(() => {

    if (values && values.catalogciius_id && listFullCatalogCiius) {
      let codigosCiius = values.catalogciiu_levels;

      let partes = codigosCiius.split(";");

      var objectCiiuFound = [];

      var currentCatalogCiiuLevelInValues = {
        1: values.catalogciiu_level1,
        2: values.catalogciiu_level2,
        3: values.catalogciiu_level3,
        4: values.catalogciiu_level4,
        5: values.catalogciiu_level5,
        6: values.catalogciiu_level6,
      };

      for (let i = 0; i < values.ciiulevel; i++) {
        objectCiiuFound[i] = getObjectByCode(partes[i], listFullCatalogCiius);

        handleChangeCatalogCiiu(objectCiiuFound[i], i + 1);

        currentCatalogCiiuLevelInValues[i + 1] = objectCiiuFound[i] && objectCiiuFound[i].id;
      }
    }

  }, [listFullCatalogCiius]);

  useEffect(() => {

    if (values && values.cataloginstitutions_id && listFullCatalogInstitutions) {
      let codigosInstitutions = values.cataloginstitution_levels;

      let partes = codigosInstitutions.split(";");

      var objectInstitutionFound = [];

      var currentCatalogInstitutionLevelInValues = {
        1: values.cataloginstitution_level1,
        2: values.cataloginstitution_level2,
        3: values.cataloginstitution_level3,

      };

      for (let i = 0; i < partes.length; i++) {
        objectInstitutionFound[i] = getObjectByCode(partes[i], listFullCatalogInstitutions);

        handleChangeCatalogInstitution(objectInstitutionFound[i], i + 1);

        currentCatalogInstitutionLevelInValues[i + 1] = objectInstitutionFound[i] && objectInstitutionFound[i].id;
      }
    }

  }, [listFullCatalogInstitutions]);

  useEffect(() => {
    if (!values) {
      return;
    }

    hydrateCatalogSelectFields(handleChange, [
      { id: values.catalogserie_id, list: listSeries, field: "catalogserie_id" },
      { id: values.catalogproblem_id, list: listProblems, field: "catalogproblem_id" }
    ]);
  }, [listSeries, listSophistications, listSizes, listTypologies, listMagnitudes, listProblems, listPriceRanges, listPermissionPublish])

  const AssistanceCallback = () => {
    debugLogPages(':: NewAssistance, AssistanceCallback, values', {values}); 

    let valuesSubmit = { ...values };

    valuesSubmit.general_adaptation = valuesSubmit.general_adaptation_string_list;
    valuesSubmit.structural_adaptation = valuesSubmit.structural_adaptation_string_list;
    valuesSubmit.specific_adaptation = valuesSubmit.specific_adaptation_string_list;
    valuesSubmit.catalogproblem_o = valuesSubmit.catalogproblem_string_list;

    valuesSubmit.deleted = false;
    valuesSubmit.is_bulkuploaded = false;

    valuesSubmit.catalogciius_i = getObjectById(valuesSubmit.catalogciius_id, listFullCatalogCiius)?.name;

    valuesSubmit.cataloginstitutions_i = getObjectById(valuesSubmit.cataloginstitutions_id, listFullCatalogInstitutions)?.name;

    valuesSubmit.deep_indicator = parseFloat(valuesSubmit.deep_indicator);
    valuesSubmit.protection_indicator = parseFloat(valuesSubmit.protection_indicator);
    valuesSubmit.applicability_indicator = parseFloat(valuesSubmit.applicability_indicator);
    valuesSubmit.relevance_indicator = parseFloat(valuesSubmit.relevance_indicator);
    valuesSubmit.mitigation_indicator = parseFloat(valuesSubmit.mitigation_indicator);
    valuesSubmit.adaptation_indicator = parseFloat(valuesSubmit.adaptation_indicator);
    valuesSubmit.performance_indicator = parseFloat(valuesSubmit.performance_indicator);

    debugLogPages(':: NewAssistance, AssistanceCallback, valuesSubmit',{valuesSubmit}); 

    const payload = attachPreDriTermOrWarn(attachModuleFormScope(valuesSubmit, visibilityFlag));
    if (!payload) {
      return;
    }
    dispatch(assistanceStartRegisterAdmin(payload, navigate, location.state?.returnTo || ""));

  };

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const getObjectByCode = (code, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.code === code);
    return elementFound;
  };

  const getMethodData = (currentData) => {
    let comboData = [];
    let level = 0;

    if (currentData === "series") {
      comboData = listSeries;
      level = 1;
    } else if (currentData === "ciius_level1") {
      comboData = listCatalogCiiusLevel1;
      level = 1;
    } else if (currentData === "ciius_level2") {
      comboData = listCatalogCiiusLevel2;
      level = 2;
    } else if (currentData === "ciius_level3") {
      comboData = listCatalogCiiusLevel3;
      level = 3;
    } else if (currentData === "ciius_level4") {
      comboData = listCatalogCiiusLevel4;
      level = 4;
    } else if (currentData === "ciius_level5") {
      comboData = listCatalogCiiusLevel5;
      level = 5;
    } else if (currentData === "ciius_level6") {
      comboData = listCatalogCiiusLevel6;
      level = 6;
    } else if (currentData === "sections_level1") {
      comboData = listCatalogSectionsLevel1;
      level = 1;
    } else if (currentData === "sections_level2") {
      comboData = listCatalogSectionsLevel2;
      level = 2;
    } else if (currentData === "sections_level3") {
      comboData = listCatalogSectionsLevel3;
      level = 3;
    } else if (currentData === "phases_level1") {
      comboData = listCatalogPhasesLevel1;
      level = 1;
    } else if (currentData === "phases_level2") {
      comboData = listCatalogPhasesLevel2;
      level = 2;
    } else if (currentData === "phases_level3") {
      comboData = listCatalogPhasesLevel3;
      level = 3;
    } else if (currentData === "phases_level4") {
      comboData = listCatalogPhasesLevel4;
      level = 4;
    } else if (currentData === "phases_level5") {
      comboData = listCatalogPhasesLevel4;
      level = 5;
    } else if (currentData === "institutions_level1") {
      comboData = listCatalogInstitutionsLevel1;
      level = 1;
    } else if (currentData === "institutions_level2") {
      comboData = listCatalogInstitutionsLevel2;
      level = 2;
    } else if (currentData === "institutions_level3") {
      comboData = listCatalogInstitutionsLevel3;
      level = 3;
    } else if (currentData === "sophistications") {
      comboData = listSophistications;
      level = 1;
    } else if (currentData === "magnitudes") {
      comboData = listMagnitudes;
      level = 1;
    } else if (currentData === "sizes") {
      comboData = listSizes;
      level = 1;
    } else if (currentData === "typologies") {
      comboData = listTypologies;
      level = 1;
    } else if (currentData === "problems") {
      comboData = listProblems;
      level = 1;
    } else if (currentData === "multimedias") {
      comboData = listMultimedias;
      level = 1;
    } else if (currentData === "continents") {
      comboData = listContinents;
      level = 1;
    } else if (currentData === "regions") {
      comboData = listRegions;
      level = 1;
    } else if (currentData === "countries") {
      comboData = listCountries;
      level = 1;
    } else if (currentData === "prices") {
      comboData = listPriceRanges;
      level = 1;
    } else if (currentData === "permission_publish") {
      comboData = listPermissionPublish;
      level = 1;
    } else if (currentData === "general_adaptation") {
      comboData = listGeneralAdaptations;
      level = 1;
    } else if (currentData === "structural_adaptation") {
      comboData = listStructuralAdaptations;
      level = 1;
    } else if (currentData === "specific_adaptation") {
      comboData = listSpecificAdaptations;
      level = 1;
    }

    return { comboData, level };
  };

  const getSelectedProblemsOriginalCatalogs = (catalogProblemsSelected, listProblems) => {
    let listCatalogProblemsDefault = [];

    catalogProblemsSelected.forEach(catalogProblem => {
      const catalogOriginal = getObjectById(catalogProblem.catalogproblem_id, listProblems);
      if (catalogOriginal) {
        listCatalogProblemsDefault.push(catalogOriginal);
      }
    })

    return listCatalogProblemsDefault;

  }

  debugLogPages(':: NewAssistance', { 'values': values });
  debugLogPages(':: NewAssistance', { 'errors': errors });


  // 1. Claves relacionales específicas para la creación de Asistencias
  const assistanceRelations = {
    problems: "ModProblem_To_Assistance",
    multimedia: "ModuleFile_To_Assistance"
  };

  // 2. Propiedades compartidas mapeadas hacia el motor dinámico
  const sharedFormProps = {
    values,
    errors,
    setValues,
    handleChange,
    handleChangeLocation,
    handleChangeMulti,
    handleChangeCatalogPhase,
    handleChangeCatalogCiiu,
    handleChangeCatalogSection,
    handleChangeCatalogInstitution, // Enviamos el handler de instituciones soportado
    getMethodData,
    listProblems,
    listMultimedias,
    getSelectedProblemsOriginalCatalogs, // Helper limpio de creación
    relationKeys: assistanceRelations,
    isEditMode: false
  };

  return (
    <div>
      <NavbarIconsModuleContext moduleProcess="assistance" mode="ficha" />
      <PreDriCreateBar process="assistance" title={t("assistance.page.register")} />
      <hr className="line-hr" />
      <div className="InfoBusqueda">
        <form onSubmit={handleSubmit} noValidate>
          <div className="row">
            <FlowFichaSections
              record={values}
              process="assistance"
              arrayListPrincipal={arrayListPrincipal}
              arrayListSecondary={arrayListSecondary}
              sharedFormProps={sharedFormProps}
            />
          </div>
          <div className="btnGuardar">
            <input type="submit" value={t("buttons.submit")} className="btn btn-primary" disabled={isDisabledProcessButton} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewAssistance;